
import { WidgetDefinition } from "./widget-types";

// These static definitions are maintained for reference and as a fallback,
// but actual widget definitions are now stored in the database
export const ADMIN_WIDGET_DEFINITIONS: WidgetDefinition[] = [
  {
    id: "total-users",
    title: "Total Users",
    description: "Shows the total number of registered users",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "admin",
    queryName: "getUserStats",
    dataFields: ["totalUsers"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "contracts",
    title: "Total Contracts",
    description: "Shows the total number of contracts across all users",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "admin",
    queryName: "getContractStats",
    dataFields: ["totalContracts"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "admin-total-value",
    title: "Total Value",
    description: "Shows the total value of all contracts in the system",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "admin",
    queryName: "getAdminValueStats",
    dataFields: ["totalContractValue"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "emails-sent",
    title: "Emails Sent",
    description: "Shows the total number of emails sent by the system",
    defaultSize: "small",
    chartType: "stat",
    dashboardType: "admin",
    queryName: "getEmailStats",
    dataFields: ["emailsSent"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "user-growth",
    title: "User Growth",
    description: "Chart showing the growth of users over time",
    defaultSize: "large",
    chartType: "line",
    dashboardType: "admin",
    queryName: "getUserGrowthTimeline",
    dataFields: ["timeline"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "error-distribution",
    title: "Error Distribution",
    description: "Pie chart showing the distribution of errors by type",
    defaultSize: "medium",
    chartType: "pie",
    dashboardType: "admin",
    queryName: "getErrorDistribution",
    dataFields: ["errorStats"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "bug-reports",
    title: "Bug Reports",
    description: "Shows recent bug reports submitted by users",
    defaultSize: "medium",
    chartType: "custom",
    dashboardType: "admin",
    customComponent: "BugReportsStatsCard",
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "recent-errors",
    title: "Recent Errors",
    description: "Table showing recent system errors",
    defaultSize: "large",
    chartType: "table",
    dashboardType: "admin",
    queryName: "getRecentErrors",
    dataFields: ["recentErrors"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "active-users",
    title: "Active Users",
    description: "Table showing most active users in the system",
    defaultSize: "medium",
    chartType: "table",
    dashboardType: "admin",
    queryName: "getActiveUsers",
    dataFields: ["activeUsers"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "notable-users",
    title: "Notable Users",
    description: "Shows users with the most contracts and highest contract values",
    defaultSize: "medium",
    chartType: "custom",
    dashboardType: "admin",
    queryName: "getNotableUsers",
    dataFields: ["userWithMostContracts", "userWithHighestValue"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "email-statistics",
    title: "Email Statistics",
    description: "Chart showing email delivery statistics",
    defaultSize: "medium",
    chartType: "bar",
    dashboardType: "admin",
    queryName: "getEmailStats",
    dataFields: ["emailStats"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "invitations-stats",
    title: "Invitations Statistics",
    description: "Statistics about user invitations",
    defaultSize: "medium",
    chartType: "custom",
    dashboardType: "admin",
    customComponent: "InvitationsStatsCard",
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "weekly-user-growth",
    title: "Weekly User Growth",
    description: "Bar chart showing weekly user registrations",
    defaultSize: "medium",
    chartType: "bar",
    dashboardType: "admin",
    queryName: "getWeeklyUserGrowth",
    dataFields: ["weeklyUsersData"],
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];
